/* Small, optional page reveals. Content stays visible without JavaScript. */
(() => {
  if (customElements.get('joffz-studio-film')) return;
  customElements.define('joffz-delivery-assurance', class extends HTMLElement {
    connectedCallback() {
      const promise = this.closest('joffz-pdp2')?.querySelector('.delivery-promise__promise-container');
      if (!promise || this.observer) return;
      this.observer = new ResizeObserver(() => { this.hidden = promise.getBoundingClientRect().height > 12; });
      this.observer.observe(promise);
    }
    disconnectedCallback() { this.observer?.disconnect(); this.observer = null; }
  });
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const seen = new WeakSet();
  const observer = new IntersectionObserver(entries => entries.forEach(entry => {
    if (!entry.isIntersecting) return;
    entry.target.classList.remove('jp2-reveal-pending');
    observer.unobserve(entry.target);
  }), { rootMargin: '0px 0px -24px 0px', threshold: .04 });
  const reveal = () => document.querySelectorAll('[data-jp2-reveal]').forEach(element => {
    if (seen.has(element)) return;
    seen.add(element);
    if (reduced.matches || element.getBoundingClientRect().top < innerHeight) return;
    element.classList.add('jp2-reveal-pending');
    observer.observe(element);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', reveal, { once: true });
  else reveal();
  document.addEventListener('shopify:section:load', reveal);
  reduced.addEventListener('change', () => {
    if (reduced.matches) document.querySelectorAll('.jp2-reveal-pending').forEach(element => element.classList.remove('jp2-reveal-pending'));
  });
  document.addEventListener('click', event => {
    const control = event.target.closest('[data-jp2-open-finish]');
    const product = document.querySelector('joffz-pdp2.is-ready');
    if (!control || !product || product.finishPosition < 0) return;
    event.preventDefault();
    product.openOptions(product.finishPosition, control);
  });
  customElements.define('joffz-studio-film', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const video = this.querySelector('video');
      const buttons = [...this.querySelectorAll('[data-film-play]')];
      if (!video || !buttons.length) return;
      const signal = this.controller.signal;
      const seek = this.querySelector('[data-film-seek]');
      const clock = this.querySelector('[data-film-time]');
      const full = this.querySelector('[data-film-fullscreen]');
      const playLabel = this.querySelector('[data-play-label]').textContent;
      const pauseLabel = this.querySelector('[data-pause-label]').textContent;
      const time = seconds => Math.floor((seconds || 0) / 60) + ':' + String(Math.floor((seconds || 0) % 60)).padStart(2, '0');
      const update = () => {
        const playing = !video.paused && !video.ended;
        buttons.forEach(button => { button.setAttribute('aria-label', playing ? pauseLabel : playLabel); button.setAttribute('aria-pressed', String(playing)); });
        this.classList.toggle('is-playing', playing);
        if (seek) {
          seek.disabled = !Number.isFinite(video.duration) || video.duration <= 0;
          seek.value = seek.disabled ? 0 : 100 * video.currentTime / video.duration;
          seek.setAttribute('aria-valuetext', time(video.currentTime) + ' / ' + time(video.duration));
        }
        if (clock) clock.textContent = time(video.currentTime);
      };
      const toggle = () => video.paused ? video.play().catch(() => update()) : video.pause();
      buttons.forEach(button => button.addEventListener('click', toggle, { signal }));
      video.addEventListener('click', toggle, { signal });
      for (const event of ['play','pause','ended','timeupdate','loadedmetadata','durationchange']) video.addEventListener(event, update, { signal });
      seek?.addEventListener('input', () => { if (Number.isFinite(video.duration)) video.currentTime = Number(seek.value) * video.duration / 100; }, { signal });
      if (full) {
        full.hidden = !document.fullscreenEnabled && !video.webkitEnterFullscreen;
        full.addEventListener('click', () => {
          if (document.fullscreenElement) document.exitFullscreen?.().catch(() => {});
          else if (this.requestFullscreen && document.fullscreenEnabled) this.requestFullscreen().catch(() => {});
          else video.webkitEnterFullscreen?.();
        }, { signal });
      }
      video.muted = true;
      video.controls = false;
      this.classList.add('is-enhanced');
      this.visibilityObserver = new IntersectionObserver(entries => { if (!entries[0].isIntersecting) video.pause(); }, { threshold: .05 });
      this.visibilityObserver.observe(this);
      update();
    }
    disconnectedCallback() {
      this.querySelector('video')?.pause();
      this.controller?.abort();
      this.visibilityObserver?.disconnect();
      this.controller = null;
    }
  });
})();
